import React, { useEffect } from "react";
import useStyles from "../common/Styles";
import { Box } from "@material-ui/core";
import ChartTitle from "../common/ChartTitle";
import TribesMap from "./TribesMap";
import TribesStackBar from "./TribesStackBar";
import userActions from '../common/actions';
import appActions from '../../../app/actions';

const ChartView = (props) => {
  const classes = useStyles();
  const { chart } = props;
  // const { tribe_selected } = useSelector((state) => state.water_user);
  const { setWaterUserChart } = userActions();
  const { setChartDrawerStateToClose } = appActions();

  const componentUnmountHook = () => {
    return () => setWaterUserChart(0);
  }
  useEffect(componentUnmountHook, []);

  return (
    <Box className={classes.chartView} onClick={()=>{ setChartDrawerStateToClose() }}>
      <ChartTitle
        floating={chart.floating_title}
        title={
          chart.id === "title_map"
            ? `Tribes with Colorado River entitlements in Central Arizona`
            : chart.title
        }
        subtitle={chart.subtitle}
        background={chart.floating_title ? "#EDEDED" : "transparent"}
      />
      {
        {
          title_map: <TribesMap />,
          tribal_shortage_impacts: <TribesStackBar />,
        }[chart.id]
      }
    </Box>
  );
};

export default ChartView;
